import React, { useState } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { t } from 'i18next';
import Button from '@mui/material/Button';
import { faBuilding, faEnvelope, faEye, faEyeSlash, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TemporaryDrawerProps {
  setShowAddCompany: any,
  refreshCompany: any,
}

export default function AddCompany({ setShowAddCompany, refreshCompany }: TemporaryDrawerProps) {
  const handleClose = () => setShowAddCompany(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfimr] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  const handleClick = async () => {

    if (!firstName || !lastName || !email || !password || !passwordConfirm) {
      enqueueSnackbar('All fields are required', { variant: 'error' });
      return;
    }
    if (!EMAIL_REGEX.test(email)) {
      enqueueSnackbar('Invalid email format', { variant: 'error' });
      return;
    }
    try {
      await axios.post('register', {
        first_name: firstName,
        last_name: lastName,
        email,
        password,
        password_confirm: passwordConfirm,
        companyid: company
      })
      enqueueSnackbar('Registration was successful', { variant: 'success' });
      handleClose();
      refreshCompany();
    } catch (e) {
      enqueueSnackbar('Registration failed. Please try again', { variant: 'error' });
    }
  }

  return (
    <Box sx={{
      width: 420,
      height: '200%',
      background: 'var(--bg-form)'
    }}
      role="presentation">
      <List>
        <div className='my-[5px] mx-[25px] text-[var(--text-color)]' id='reg-user-edit'>
          <div className='flex justify-end'>
            <h1 className='text-[20px] text-left font-bold'>{t('AddCompany')}</h1>
          </div>
          <div className='flex flex-col justify-evenly flex-grow' >
            <hr className='hr mt-[10px]' />
            <h2 className='text-[14px] my-[5px] font-semibold text-right'>{t('Information')}</h2>
            <hr className='hr mt-1 mb-[5px]' />
            <div className='flex flex-col mb-[5px] w-full'>
              <label className='text-[12px] ml-[5px]'>{t('FirstName')}:</label>
              <div className='w-full flex-grow relative'>
                <input
                  type="text"
                  className='w-full input-timesheet text-[var(--text-color)] text-[16px] bg-[var(--bg-input)] py-[5px] pl-[10px] pr-[25px] rounded-[5px] '
                  placeholder={t('FirstName')}
                  id='first-name'
                  onChange={e => setFirstName(e.target.value)} />
                <FontAwesomeIcon
                  icon={faUser}
                  className='absolute top-[50%] translate-y-[-50%] right-[10px] text-[14px] text-[--text-color] opacity-50' />
              </div>
            </div>
            <div className='flex flex-col mb-[5px] w-full'>
              <label className='text-[12px] ml-[5px]'>{t('LastName')}:</label>
              <div className='w-full flex-grow relative'>
                <input
                  type="text"
                  className='w-full input-timesheet text-[var(--text-color)] text-[16px] bg-[var(--bg-input)] py-[5px] pl-[10px] pr-[25px] rounded-[5px] '
                  placeholder={t('LastName')}
                  id='last-name'
                  onChange={e => setLastName(e.target.value)} />
                <FontAwesomeIcon
                  icon={faUser}
                  className='absolute top-[50%] translate-y-[-50%] right-[10px] text-[14px] text-[--text-color] opacity-50' />
              </div>
            </div>
            <div className='flex flex-col mb-[5px] w-full'>
              <label className='text-[12px] ml-[5px]'>{t('Email')}:</label>
              <div className='w-full flex-grow relative'>
                <input
                  type="text"
                  className='w-full input-timesheet text-[var(--text-color)] text-[16px] bg-[var(--bg-input)] py-[5px] pl-[10px] pr-[25px] rounded-[5px] '
                  placeholder={t('Email')}
                  id='email'
                  onChange={e => setEmail(e.target.value)} />
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className='absolute top-[50%] translate-y-[-50%] right-[10px] text-[14px] text-[--text-color] opacity-50' />
              </div>
            </div>
            <div className='flex flex-col mb-[5px] w-full'>
              <label className='text-[12px] ml-[5px]'>{t('Company')}:</label>
              <div className='w-full flex-grow relative'>
                <input
                  type="text"
                  className='w-full input-timesheet text-[var(--text-color)] text-[16px] bg-[var(--bg-input)] py-[5px] pl-[10px] pr-[25px] rounded-[5px] '
                  placeholder={t('Company')}
                  id='register'
                  onChange={e => setCompany(e.target.value)} />
                <FontAwesomeIcon
                  icon={faBuilding}
                  className='absolute top-[50%] translate-y-[-50%] right-[10px] text-[14px] text-[--text-color] opacity-50' />
              </div>
            </div>
            <div className='flex flex-col mb-[5px] w-full'>
              <label className='text-[12px] ml-[5px]'>{t('Password')}:</label>
              <div className='w-full relative flex-grow'>
                <input
                  type={showPassword ? "text" : "password"}
                  className='w-full input-timesheet text-[var(--text-color)] text-[16px] bg-[var(--bg-input)] p-[5px] pl-[10px] rounded-[5px]'
                  placeholder={t('Password')}
                  id='password'
                  onChange={e => setPassword(e.target.value)} />
                {showPassword ? (
                  <FontAwesomeIcon
                    icon={faEyeSlash}
                    className='absolute top-[50%] translate-y-[-50%] right-[10px] text-[14px] text-[--text-color] opacity-50 cursor-pointer hover:opacity-70'
                    onClick={() => setShowPassword(!showPassword)} />
                ) : (
                  <FontAwesomeIcon
                    icon={faEye}
                    className='absolute top-[50%] translate-y-[-50%] right-[10px] text-[14px] text-[--text-color] opacity-50 cursor-pointer hover:opacity-70'
                    onClick={() => setShowPassword(!showPassword)} />
                )}
              </div>
            </div>
            <div className='flex flex-col mb-[5px] w-full'>
              <label className='text-[12px] ml-[5px]'>{t('ConfirmPassword')}:</label>
              <div className='w-full relative flex-grow'>
                <input
                  type={showPasswordConfirm ? "text" : "password"}
                  className='w-full input-timesheet text-[var(--text-color)] text-[16px] bg-[var(--bg-input)] p-[5px] pl-[10px] rounded-[5px]'
                  placeholder={t('ConfirmPassword')}
                  id='confirm_pwd'
                  onChange={e => setPasswordConfirm(e.target.value)} />
                {showPasswordConfirm ? (
                  <FontAwesomeIcon
                    icon={faEyeSlash}
                    className='absolute top-[50%] translate-y-[-50%] right-[10px] text-[14px] text-[--text-color] opacity-50 cursor-pointer hover:opacity-70'
                    onClick={() => setShowPasswordConfimr(!showPasswordConfirm)} />
                ) : (
                  <FontAwesomeIcon
                    icon={faEye}
                    className='absolute top-[50%] translate-y-[-50%] right-[10px] text-[14px] text-[--text-color] opacity-50 cursor-pointer hover:opacity-70'
                    onClick={() => setShowPasswordConfimr(!showPasswordConfirm)} />
                )}
              </div>
            </div>
            <hr className='hr mt-1 mb-[10px]' />
            <div className='flex mt-[20px] justify-center items-center gap-[10px]'>
              <Button
                variant="contained"
                sx={{
                  padding: '5px 10px',
                  fontSize: 14,
                  width: '100%',
                  color: 'white !important'
                }}
                onClick={() => handleClick()}
              >
                {t('Create')}
              </Button>
              <Button
                variant="contained"
                sx={{
                  padding: '5px 10px',
                  fontSize: 14,
                  width: '100%',
                  color: 'white !important'
                }}
                onClick={() => setShowAddCompany(false)}>
                {t('Cancel')}
              </Button>
            </div>
          </div>
        </div>
      </List>
    </Box>
  )
}